import GeneralBtn from "src/components/GeneralBtn";
import { Box } from "src/components/MuiGenerals";
import { customSx } from "src/utils/styling";
import { usePageConfigProviderContext } from "..";

const SearchAndResetBox = () => {
  const { onFilterSearch, onFilterReset } = usePageConfigProviderContext();
  return (
    <Box sx={customSx.filterB}>
      <GeneralBtn label="search" onClick={onFilterSearch} />
      <GeneralBtn label="reset" onClick={onFilterReset} />
    </Box>
  );
};
export default SearchAndResetBox;
